<template>
  <Modal
    v-bind="$attrs"
    title="Informações"
    :titleIcons="titleIcons"
    :hasActions="false"
    :width="computedWidth"
    @close="$emit('close')"
    @save="$emit('close')"
  >
    <div v-if="!!produto">
      <v-card class="mb-3">
        <v-card-text class="px-0">
          <v-carousel
            v-model="carousel"
            :height="carouselHeight"
            hide-delimiters
            :show-arrows="produto.imagens.length > 1"
          >
            <v-carousel-item
              v-for="(imagem, i) of produto.imagens"
              :key="i"
              :src="imagem"
              contain
            ></v-carousel-item>
          </v-carousel>
        </v-card-text>
      </v-card>
      <CardTitle title="Produto" class="mb-4">
        <div class="d-flex justify-space-between align-center">
          <p class="font-weight-bold mb-0">{{ produto.descricao }}</p>
        </div>
      </CardTitle>
      <CardTitle title="Última Venda" v-if="produto.informacoes">
        <div class="d-flex justify-space-between align-center">
          <span>Data</span>
          <p class="font-weight-bold mb-0">{{ dataUltimaVenda }}</p>
        </div>
        <v-divider class="my-1"></v-divider>
        <div class="d-flex justify-space-between align-center">
          <span>Quantidade</span>
          <p class="font-weight-bold mb-0">{{ `${produto.informacoes.qtde_produto} ${produto.informacoes.unidade}` }}</p>
        </div>
        <v-divider class="my-1"></v-divider>
        <div class="d-flex justify-space-between align-center">
          <span>Preço Bruto</span>
          <p class="font-weight-bold mb-0">{{ produto.informacoes.preco_bruto | price }}</p>
        </div>
        <v-divider class="my-1"></v-divider>
        <div class="d-flex justify-space-between align-center">
          <span>Desconto</span>
          <p class="font-weight-bold mb-0">{{ produto.informacoes.desconto | price }}</p>
        </div>
        <v-divider class="my-1"></v-divider>
        <div class="d-flex justify-space-between align-center">
          <span>Subtotal</span>
          <p class="font-weight-bold mb-0">{{ produto.informacoes.subtotal_produto | price }}</p>
        </div>
        <v-divider class="my-1"></v-divider>
      </CardTitle>
      <Alert
        v-else
        type="error"
        text="Não foi possível obter informações"
        :alertClass="$vuetify.breakpoint.xs ? 'caption my-3' : 'my-3'"
      />
    </div>
    <PageLoading v-else />
  </Modal>
</template>

<script>
export default {
  name: 'ModalInfoProduto',
  props: {
    produto: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    carousel: 0,
    titleIcons: [
      {
        name: 'mdi-close',
        event: 'close',
        loading: false
      }
    ]
  }),
  watch: {
    produto(value) {
      if (!value) {
        this.carousel = 0;
      }
    }
  },
  components: {
    Modal: () => import('@/components/shared/Modal'),
    Alert: () => import('@/components/shared/Alert'),
    CardTitle: () => import('@/components/shared/CardTitle'),
  },
  computed: {
    dataUltimaVenda() {
      if (this.produto && this.produto.informacoes) {
        const data = this.produto.informacoes.data_emissao;

        return data === '1899-12-30' ? 'Nenhuma' : this.$options.filters.dateMonthYear(data);
      }

      return 'Nenhuma';
    },
    computedWidth() {
      const breakpoint = this.$vuetify.breakpoint;
      
      if (breakpoint.xs) return '';
      if (breakpoint.sm) return '500px';
      if (breakpoint.md) return '768px';
      if (breakpoint.lg) return '768px';
      if (breakpoint.xl) return '768px';

      return '300px';
    },
    carouselHeight() {
      const breakpoint = this.$vuetify.breakpoint;
      
      if (breakpoint.xs) return '150';
      if (breakpoint.sm) return '300';
      if (breakpoint.md) return '300';
      if (breakpoint.lg) return '300';
      if (breakpoint.xl) return '300';

      return '150';
    }
  }
}
</script>

<style>

</style>